export default [
    {
        name: 'particlesModel',
        type: 'gltfModel',
        path: 'models/particlesnewdef.glb'
    },
    {
        name: 'stagesModel',
        type: 'gltfModel',
        path: 'models/stadiennewdef.glb'
    }


]